<template>
    <v-content class="">
        <section>
            <v-parallax
                    :src="require('@/assets/beach-tsv2.jpg')"
                    height="500"
                    class="banner"
            >
                <Navbar></Navbar>

                <v-layout column class="white--text " justify-end>
                    <div>
                        <v-container justify-end>
                            <div class=" display-1  mt-3 subpage-heading-1 ">
                                Estimating Resilience
                            </div>
                            <div class=" headline  mt-3 subpage-heading-2 ">
                                Technical notes
                            </div>
                        </v-container>
                    </div>
                </v-layout>
            </v-parallax>
        </section>

        <section>
            <v-container class=" white-background ">

                <v-breadcrumbs divider="-">
                    <v-breadcrumbs-item @click="gotoResilience">Resilience</v-breadcrumbs-item>
                    <v-breadcrumbs-item > > </v-breadcrumbs-item>
                    <v-breadcrumbs-item
                    >Estimating Resilience</v-breadcrumbs-item
                    >
                </v-breadcrumbs>

                <section>
                    <v-container grid-list-xl class=" white-background">
                        <v-layout row wrap align-center>
                            <v-flex xs12>
                                <v-card class="elevation-0 transparent text-center">
                                    <h2 class="headline pa-2">Estimating Resilience</h2>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </section>

                <v-layout column wrap class="" align-center>
                    <p>
                        The resilience scores provided in the inspection report give an indication
                        of the likelihood of your property surviving a cyclone without suffering
                        significant damage. The resilience scores are between 1 and 5. The table
                        below summarises the interpretation of the resilience scores for different
                        wind speeds.
                    </p>
                    <p>
                        <em>
                            Note: When using this table, it is the wind speed <u>at your town</u>
                            that is important, not the wind speeds associated with the
                            classification (e.g. Category 4) given to the cyclone. Refer to the
                            section ‘Wind speeds at your location’ for more information.
                        </em>
                    </p>
                    <table border="1" cellspacing="0" cellpadding="0">
                        <tbody>
                        <tr>
                            <td width="105" valign="top">
                                <p>
                                    <strong>Resilience score</strong>
                                </p>
                            </td>
                            <td width="149" valign="top">
                                <p align="center">
                                    <strong>Resilience</strong>
                                </p>
                            </td>
                            <td width="171" valign="top">
                                <p align="center">
                                    <strong>
                                        Likelihood of significant damage at around 250 km/hr
                                        winds
                                    </strong>
                                </p>
                            </td>
                            <td width="176" valign="top">
                                <p align="center">
                                    <strong>Likelihood of significant damage at around</strong>
                                </p>
                                <p align="center">
                                    <strong>180 km/hr winds</strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width="105" valign="top">
                                <p>
                                    0 to 1.5
                                </p>
                            </td>
                            <td width="149" valign="top">
                                <p align="center">
                                    Very low
                                </p>
                            </td>
                            <td width="171" valign="top">
                                <p align="center">
                                    Almost certain
                                </p>
                            </td>
                            <td width="176" valign="top">
                                <p align="center">
                                    Likely
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width="105" valign="top">
                                <p>
                                    1.5 to 2.4
                                </p>
                            </td>
                            <td width="149" valign="top">
                                <p align="center">
                                    Low
                                </p>
                            </td>
                            <td width="171" valign="top">
                                <p align="center">
                                    Likely
                                </p>
                            </td>
                            <td width="176" valign="top">
                                <p align="center">
                                    Possible
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width="105" valign="top">
                                <p>
                                    2.5 to 2.9
                                </p>
                            </td>
                            <td width="149" valign="top">
                                <p align="center">
                                    Medium
                                </p>
                            </td>
                            <td width="171" valign="top">
                                <p align="center">
                                    Possible
                                </p>
                            </td>
                            <td width="176" valign="top">
                                <p align="center">
                                    Not likely
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width="105" valign="top">
                                <p>
                                    3.0 to 4.0
                                </p>
                            </td>
                            <td width="149" valign="top">
                                <p align="center">
                                    High
                                </p>
                            </td>
                            <td width="171" valign="top">
                                <p align="center">
                                    Not likely
                                </p>
                            </td>
                            <td width="176" valign="top">
                                <p align="center">
                                    Very unlikely
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td width="105" valign="top">
                                <p>
                                    4.1 to 5
                                </p>
                            </td>
                            <td width="149" valign="top">
                                <p align="center">
                                    Very high
                                </p>
                            </td>
                            <td width="171" valign="top">
                                <p align="center">
                                    Very unlikely
                                </p>
                            </td>
                            <td width="176" valign="top">
                                <p align="center">
                                    Very unlikely
                                </p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <p>
                        <strong>Likelihood of damage by 250 km/hr wind speeds</strong>
                    </p>
                    <p>
                        If the wind speeds at the town in which your property is located are
                        equivalent to a direct hit by a Category 4 cyclone (wind speeds greater
                        than 225 km/hr), the loads placed on all parts of your building will be
                        close to the loads designers used to design your buildings. The blue-shaded
                        column indicates the likelihood of significant damage (i.e. damage that
                        means that people can no longer use the building). For example, if the
                        resilience score for Wind for your building is 2.2, then the resilience of
                        that building to wind damage is ‘Low’, and it is ‘Likely’ that it will be
                        significantly damaged by the wind during a direct hit by a Category 4
                        cyclone. Similarly, if the resilience score for Rain for your building is
                        4.1, then the resilience of that building to significant damage from
                        rainwater entering your building is ‘High’, and it is ‘Not likely’ that it
                        will be severely damaged by rainwater during a Category 4 cyclone.
                    </p>
                    <p>
                        <strong>Likelihood of damage by 180 km/hr wind speeds</strong>
                    </p>
                    <p>
                        The green-shaded column indicates the likelihood of significant damage from
                        a direct hit by a Category 2 or 3 cyclone. For example, if the resilience
                        score for Wind for your building is 2.2, then the resilience of that
                        building to wind damage is ‘Low’, and it is ‘Possible’ that it will be
                        significantly damaged by the wind during a direct hit by a Category 2 or 3
                        cyclone. Similarly, if the resilience score for Rain for a particular
                        building is 4.1, then the resilience of that building to significant damage
                        from rainwater is ‘High’, and it is ‘Very unlikely’ that it will be
                        severely damaged by rainwater entering your building during a Category 2 or
                        3 cyclone.
                    </p>
                    <p>
                        <strong>Interpreting the scores</strong>
                    </p>
                    <p>
                        The resilience scores and the likelihood of significant damage must be
                        interpreted as estimates only, as damage investigations have shown that
                        levels of damage can vary widely, even between apparently similar buildings
                        – many factors contribute to whether a building is damaged during a
                        cyclone. It is possible that even buildings that are assessed as very
                        resilient can sustain damage during a tropical cyclone if large debris
                        strikes the building, wind speeds exceed the design value, or other unusual
                        combinations of events overload the building. Conversely, some buildings
                        with relatively low resilience scores may survive an event with minimal
                        damage.
                    </p>
                    <p>
                        The report provides guidance to strata property owners rather than a
                        guarantee. It can be used to identify the more vulnerable parts of their
                        building so they can be addressed by building professionals to improve the
                        resilience of the property in future tropical cyclones.
                    </p>
                    <p>
                        <strong>Wind speeds at your location</strong>
                    </p>
                    <p>
                        Different towns within the area affected by a cyclone will experience
                        different wind speeds depending on how close the town is to the centre of
                        the cyclone.
                    </p>
                    <div>
                        <p>
                            Unless your property experienced the ‘eye’ of the cyclone, the wind
                            speeds at your town are likely to be lower than the wind speeds given
                            by the Bureau of Meteorology for that cyclone.
                        </p>
                    </div>
                    <p>
                        The Bureau of Meteorology (BoM) predicts the severity of a tropical cyclone
                        using a five-category system based on the maximum expected gust wind speed
                        at the edge of the eye of the cyclone. Also refer to the information on
                        <a @click="gotoDamage">
                            damage to buildings
                        </a>
                    </p>
                    <p>
                        <strong>Tropical cyclone categories</strong>
                        <strong></strong>
                    </p>
                    <div align="center">
                        <table border="1" cellspacing="0" cellpadding="0">
                            <tbody>
                            <tr>
                                <td width="114" valign="top">
                                    <p>
                                        <strong>Cyclone category</strong>
                                        <strong></strong>
                                    </p>
                                </td>
                                <td width="120" valign="top">
                                    <p>
                                        <strong>Strongest gust </strong>
                                        <strong>(</strong>
                                        km/h<strong>)</strong>
                                    </p>
                                </td>
                                <td width="350" valign="top">
                                    <p>
                                        <strong>
                                            Typical effects near the ‘eye’ of the cyclone
                                        </strong>
                                        <strong></strong>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td width="114" valign="top">
                                    <p>
                                        1
                                    </p>
                                </td>
                                <td width="120" valign="top">
                                    <p>
                                        &lt; 125 km/h
                                    </p>
                                </td>
                                <td width="350" valign="top">
                                    <ul>
                                        <li>
                                            minimal damage to buildings
                                        </li>
                                        <li>
                                            damage to some crops, trees and caravans
                                        </li>
                                        <li>
                                            boats may drag their moorings
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td width="114" valign="top">
                                    <p>
                                        2
                                    </p>
                                </td>
                                <td width="120" valign="top">
                                    <p>
                                        125-169 km/h
                                    </p>
                                </td>
                                <td width="350" valign="top">
                                    <ul>
                                        <li>
                                            minor damage to buildings e.g. loss of gutters,
                                            small volumes of wind-driven rain enter buildings
                                            through gaps
                                        </li>
                                        <li>
                                            significant damage to signs, trees and caravans
                                        </li>
                                        <li>
                                            severe damage to some crops
                                        </li>
                                        <li>
                                            risk of power failure
                                        </li>
                                        <li>
                                            small boats may break moorings
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td width="114" valign="top">
                                    <p>
                                        3 (severe)
                                    </p>
                                </td>
                                <td width="120" valign="top">
                                    <p>
                                        170-224 km/h
                                    </p>
                                </td>
                                <td width="350" valign="top">
                                    <ul>
                                        <li>
                                            structural damage to older buildings that haven’t
                                            been upgraded and maintained
                                        </li>
                                        <li>
                                            destruction of some caravans
                                        </li>
                                        <li>
                                            likely power failure
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td width="114" valign="top">
                                    <p>
                                        4 (severe)
                                    </p>
                                </td>
                                <td width="120" valign="top">
                                    <p>
                                        225-280 km/h
                                    </p>
                                </td>
                                <td width="350" valign="top">
                                    <ul>
                                        <li>
                                            significant structural damage to older buildings
                                            that haven’t been upgraded and maintained
                                        </li>
                                        <li>
                                            many caravans destroyed and blown away
                                        </li>
                                        <li>
                                            dangerous airborne debris
                                        </li>
                                        <li>
                                            widespread power failures
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td width="114" valign="top">
                                    <p>
                                        5 (severe)
                                    </p>
                                </td>
                                <td width="120" valign="top">
                                    <p>
                                        &gt; 280 km/h
                                    </p>
                                </td>
                                <td width="350" valign="top">
                                    <p>
                                        potential for widespread and severe damage
                                    </p>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <p>
                        <strong></strong>
                    </p>
                    <p>
                        Tropical cyclones are often hundreds of kilometres wide, travel several
                        hundred kilometres and affect thousands of square kilometres of land. The
                        highest winds are just outside the ‘eye’ (centre), and the peak gust wind
                        speed decreases further away from the edge of the eye.
                    </p>
                    <p>
                        The wind speed at a town can be different to the wind speeds reported by
                        the BoM. Weakened tropical cyclones frequently pass into non-cyclonic
                        areas, but by then, the wind speeds are much lower than when they crossed
                        the coastline. For example, Severe Tropical Cyclone Yasi was a Category 5
                        cyclone that formed over the Coral Sea and crossed the coastline with wind
                        gusts in the Category 4 range. Properties located approximately 50
                        kilometres from the eye of the cyclone experienced winds equivalent to a
                        Category 3 event. As the cyclone tracked further inland, the cyclone
                        weakened and gust wind speeds decreased, as illustrated in the diagram. The
                        media referred to TC Yasi as “Category 5 TC Yasi”, but the majority of
                        buildings did not experience Category 4 or 5 wind speeds – for example,
                        those in Townsville experienced Category 1 or 2 wind speeds.
                    </p>

                    <p>
                        <em>
                            Estimated maximum gust wind speeds in Queensland from Severe Tropical
                            Cyclone Yasi (2011)
                        </em>
                        <em></em>
                    </p>
                    <v-img
                            :src="require('@/assets/estimate.jpg')"

                            width="700"
                    ></v-img>


                </v-layout>
            </v-container>
        </section>

        <Footer></Footer>
    </v-content>
</template>

<style></style>

<script>
  import image1 from "../assets/wind-1.jpg";
  import image2 from "../assets/1_wind.jpg";
  import image3 from "../assets/2_wind.jpg";
  import image4 from "../assets/3_wind.jpg";
  import image5 from "../assets/4_wind.jpg";
  import image6 from "../assets/5_wind.jpg";
  import image7 from "../assets/6_wind.jpg";
  import image8 from "../assets/7_wind.jpg";
  import image9 from "../assets/8_wind.jpg";
  import image10 from "../assets/9_wind.jpg";
  import image11 from "../assets/10_wind.jpg";
  import image12 from "../assets/11_wind.jpg";
  import image13 from "../assets/12_wind.jpg";
  import image14 from "../assets/11_debris.jpg";
  import image15 from "../assets/13_debris.jpg";
  import image16 from "../assets/14_debris.jpg";
  import image17 from "../assets/16_debris.jpg";
  import Footer from "./Footer.vue";
  import Navbar from "./Navbar.vue";
  import { router } from "../router";

  export default {
    name: "Wind",
    components: {
      Navbar,
      Footer
    },
    data: () => ({

    }),
  methods: {
    gotoDamage() {
      router.push("/damage");
    },
    gotoResilience() {
      router.push("/resilience");
    }
  }

  };
</script>
